import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './Pagination.scss';

import Button from '../../atoms/Button/Button';
// import useDetectDevice from '../../../functionality/Hooks/detectDevice';

const Pagination = ({ currentPage, isLoadingPeopleContacts, paginate, totalPages }) => {
  const pageNumbers = [];

  for (let i = 2; i < Math.ceil(totalPages); i++) {
    pageNumbers.push(i);
  }

  // const isMobile = useDetectDevice(768);

  const [activeButton, setActiveButton] = React.useState(1);

  React.useEffect(() => {
    setActiveButton(currentPage);
  }, [currentPage]);

  return (
    <div className="tmx-pagination__pagination">
      <Button
        className="tmx-pagination__paginationBtn btnRight"
        buttonIcon="arrow-right"
        iconSize="ginormous"
        disabled={currentPage === 1}
        handleClick={() => {
          setActiveButton(currentPage - 1);
          paginate(currentPage - 1);
        }}></Button>

      <Button
        className={classNames('tmx-pagination__paginationBtn btn', {
          active: currentPage === 1
        })}
        handleClick={() => {
          setActiveButton(1);
          paginate(1);
        }}
        disabled={currentPage === 1}
        spinner={isLoadingPeopleContacts && activeButton === 1}
        spinnerPosition="left"
        iconSize={'paginationButton'}>
        {activeButton === 1 && isLoadingPeopleContacts ? null : 1}
      </Button>

      {/* {totalPages > 10 && currentPage > 2 && <span className="tmx-pagination__ellipses">...</span>} */}

      {pageNumbers.map((number, index) => {
        const additionalPagesToShow = 4;
        const maxLowerPages = currentPage - additionalPagesToShow - 1;

        if (
          number > currentPage + additionalPagesToShow &&
          number < totalPages &&
          index === currentPage + additionalPagesToShow - 1
        ) {
          return (
            <span className="tmx-pagination__ellipses" key={index}>
              ...
            </span>
          );
        } else if (number > currentPage + additionalPagesToShow && number < totalPages) {
          return null;
        }

        if (
          (index === maxLowerPages - 1 &&
            number >= 1 &&
            number < currentPage &&
            currentPage > additionalPagesToShow - 1) ||
          (currentPage === additionalPagesToShow + 1 && number === 1)
        ) {
          return (
            <span className="tmx-pagination__ellipses" key={index}>
              ...
            </span>
          );
        } else if (number <= currentPage - additionalPagesToShow && number > 1) {
          return null;
        }
        return (
          <Button
            className={classNames('tmx-pagination__paginationBtn btn', {
              active: currentPage === number
            })}
            key={index}
            handleClick={() => {
              setActiveButton(number);
              paginate(number);
            }}
            disabled={currentPage === number}
            spinner={isLoadingPeopleContacts && activeButton === number}
            spinnerPosition="left"
            iconSize="paginationButton">
            {activeButton === number && isLoadingPeopleContacts ? null : number}
          </Button>
        );
      })}

      {/* {totalPages > 10 && currentPage < totalPages - 2 && (
        <span className="tmx-pagination__ellipses">...</span>
      )} */}

      {totalPages > 10 && (
        <Button
          className={classNames('tmx-pagination__paginationBtn btn', {
            active: currentPage === totalPages
          })}
          handleClick={() => {
            setActiveButton(totalPages);
            paginate(totalPages);
          }}
          disabled={currentPage === totalPages}
          spinner={isLoadingPeopleContacts && activeButton === totalPages}
          spinnerPosition="left"
          iconSize={'paginationButton'}>
          {activeButton === totalPages && isLoadingPeopleContacts ? null : totalPages}
        </Button>
      )}

      <Button
        className="tmx-pagination__paginationBtn btn"
        buttonIcon="arrow-right"
        iconSize="ginormous"
        disabled={currentPage === totalPages}
        handleClick={() => {
          setActiveButton(currentPage + 1);
          paginate(currentPage + 1);
        }}></Button>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number,
  isLoadingPeopleContacts: PropTypes.bool,
  paginate: PropTypes.func,
  spinner: PropTypes.bool,
  totalPages: PropTypes.number
};

export default Pagination;
